import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { ProvisionItemReturnStatusEnum } from "../../data/enums";

export namespace ProvisionReturnValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Finish = defineValidation(
        v.object({
            depositorId: baseVals.string(),
            items: v.array(
                v.object({
                    id: baseVals.string(),
                    status: v.picklist(ProvisionItemReturnStatusEnum.values),
                }),
            ),
        }),
    );
}
